import { Injectable } from '@angular/core';
import { BoardSummary } from 'app/trello/models/board-summary';
import { BoardSummaryFilter as PureBoardSummaryFilter } from 'app/trello/workers/pure-services/board-summary-filter';
import { BoardSummaryMapper as PureBoardSummaryMapper } from 'app/trello/workers/pure-services/board-summary-mapper';

@Injectable({
  providedIn: 'root'
})
export class BoardSummaryMapperSync {

  private readonly boardSummaryMapper: PureBoardSummaryMapper =
    new PureBoardSummaryMapper(
      new PureBoardSummaryFilter()
    );

  public map(
    boardSummary: BoardSummary,
  ): BoardSummary {

    return this.boardSummaryMapper.map(boardSummary);
  }

}
